import { observer } from 'mobx-react-lite';

import { IcBackIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import { useThreadInfoPresenter } from './ThreadInfo.presenter';
import styles from './ThreadInfo.styles.m.css';

export const ThreadInfo = observer(() => {
  const presenter = useThreadInfoPresenter();

  return (
    <div className={styles.container}>
      <AddKeyPressHandler onEsc={presenter.onBack} />
      <IconButton
        className={styles.back}
        Icon={IcBackIcon}
        onClick={presenter.onBack}
        size={IconViewSizes.Big}
        iconSize={IconViewSizes.Medium}
        theme="8"
      />
      {presenter.title}
    </div>
  );
});
